// Vendor Libraries
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {map, sortBy, startCase, take, toLower} from 'lodash';

// Components
import Button from '../core/button';
import RecordDetails from '../core/record-details';
import Thumbnail from '../core/thumbnail';

// Styles
import './movies-and-programs-credits.scss';

export default class MoviesAndProgramsCredits extends Component {
    state = {
        limit: typeof this.props.limit === 'undefined' ? 10 : this.props.limit, // eslint-disable-line react/destructuring-assignment
    };

    handleAllButtonClick = () => {
        this.setState({
            limit: 9999,
        });
    };

    handleMoreButtonClick = () => {
        const {limitIncrement = 10} = this.props;

        this.setState((state) => ({
            limit: state.limit + limitIncrement,
        }));
    };

    renderButtons() {
        const {searchValues} = this.props;
        const {limit} = this.state;

        return limit > 0 && searchValues.length > limit ? (
            <div className="movies-and-programs-credits--buttons">
                <Button
                    className="movies-and-programs-credits--button"
                    type="link"
                    onClick={this.handleMoreButtonClick}
                >
                    Show more credits
                </Button>
                <Button className="movies-and-programs-credits--button" type="link" onClick={this.handleAllButtonClick}>
                    Show all {searchValues.length} credits
                </Button>
            </div>
        ) : null;
    }

    renderThumbnails({celebrityImages}) {
        const sortedImages = sortBy(celebrityImages, (image) => image.category);

        return sortedImages.length ? (
            <div className="movies-and-programs-credits--thumbnails">
                {map(sortedImages, ({category, imageHeight, imageWidth, url}, key) => (
                    <Thumbnail
                        className="movies-and-programs-credits--thumbnail"
                        height={imageHeight}
                        key={key}
                        label={startCase(toLower(category))}
                        src={url}
                        width={imageWidth}
                    />
                ))}
            </div>
        ) : null;
    }

    render() {
        const {limit} = this.state;
        const {searchValues} = this.props;
        const creditsSorted = take(
            sortBy(searchValues, (credit) => credit.sequenceNumber || 9999),
            limit
        );

        return creditsSorted.length ? (
            <div className="movies-and-programs-credits">
                {map(creditsSorted, (record, index) => (
                    <div className="movies-and-programs-credits--credit" key={index}>
                        {this.renderThumbnails(record)}
                        <RecordDetails className="movies-and-programs-credits--record-details" searchData={[record]} />
                    </div>
                ))}
                {this.renderButtons()}
            </div>
        ) : null;
    }
}

MoviesAndProgramsCredits.propTypes = {
    limit: PropTypes.number,
    limitIncrement: PropTypes.number,
    searchValues: PropTypes.array.isRequired,
};
